import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut } from 'react-chartjs-2';

const DonutGauge = ({
  percent,
  cutoutPercentage = 50,
  rotation = -0.5 * Math.PI,
  animate = true,
  color,
  remainderColor,
  ...otherProps
}) => {
  const remainder = 100 - percent;
  const data = {
    datasets: [
      {
        data: [remainder, percent],
        borderWidth: 0,
        backgroundColor: [remainderColor, color]
      }
    ]
  };
  const options = {
    cutoutPercentage,
    rotation,
    animation: { animateRotate: animate },
    tooltips: { enabled: false }
  };
  return (
    <Doughnut type="doughnut" data={data} options={options} {...otherProps} />
  );
};

DonutGauge.propTypes = {
  percent: PropTypes.number.isRequired,
  cutoutPercentage: PropTypes.number,
  rotation: PropTypes.number,
  animate: PropTypes.bool,
  color: PropTypes.string.isRequired,
  remainderColor: PropTypes.string.isRequired
};

export default DonutGauge;
